
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryPack50 as ObiBatteryPack50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-pack-50.js';
 
 
 

 
 export const ObiBatteryPack50 = createComponent({
   react: React,
   tagName: 'obi-battery-pack-50',
   elementClass: ObiBatteryPack50Element,
   events: {
     
   }
  });
 
 